export function imgError(pUrl) {
  let img = event.srcElement
  img.src = pUrl
  img.onerror = null
}

export function reContent(pContent) {
  let _result = pContent.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, (match, reSrc) => {
    let newImg = match.substring(0, match.length - 1) + 'style="max-width:100%;" />'
    // if(reSrc.indexOf('http') == -1) {
    //   newImg = '<img src="' + reSrc +'" alt="" style="max-width:100%;" />'
    // }
    newImg = '<img src="' + reSrc +'" alt="" style="max-width:100%;" />'
    return newImg
  })
  _result = _result.replace(/<video [^>]*src=['"]([^'"]+)[^>]*>/gi, (match) => {
    let newImg = match.substring(0, match.length - 1) + 'style="max-width:100%;">'
    return newImg
  })
  _result = _result.replace(/<iframe [^>]*src=['"]([^'"]+)[^>]*>/gi, (match) => {
    let newImg = match.substring(0, match.length - 1) + 'style="max-width:100%;">'
    return newImg
  })
  return _result
}
